import { Trash2 } from "lucide-react";

export const ItemEditor = ({ item, index, onChange, onDelete }) => (
  <div
    data-testid={`admin-item-editor-${item.id}`}
    className="border border-[#2c3528]/12 bg-[#f9f6f0] p-4 md:p-5"
  >
    <div className="flex items-start justify-between gap-4 mb-4">
      <p data-testid={`admin-item-number-${item.id}`} className="overline text-[#d98a6c]">
        Item {String(index + 1).padStart(2, "0")}
      </p>
      <button
        type="button"
        data-testid={`admin-delete-item-button-${item.id}`}
        onClick={onDelete}
        className="lift h-9 w-9 grid place-items-center border border-[#2c3528]/20 text-[#2c3528] hover:bg-[#8f3d2f] hover:border-[#8f3d2f] hover:text-[#f9f6f0]"
        aria-label={`Delete ${item.name || "menu item"}`}
      >
        <Trash2 className="h-4 w-4" strokeWidth={1.7} />
      </button>
    </div>

    <div className="grid md:grid-cols-2 gap-4">
      <label className="block">
        <span className="text-xs tracking-[0.16em] uppercase text-[#2c3528]/65">Name</span>
        <input
          data-testid={`admin-item-name-input-${item.id}`}
          value={item.name}
          onChange={(event) => onChange("name", event.target.value)}
          className="mt-2 w-full bg-white/60 border border-[#2c3528]/20 px-4 py-3 text-[#2c3528] outline-none focus:border-[#5b7053]"
          placeholder="Lamb Kleftiko"
        />
      </label>
      <label className="block">
        <span className="text-xs tracking-[0.16em] uppercase text-[#2c3528]/65">Price</span>
        <input
          data-testid={`admin-item-price-input-${item.id}`}
          value={item.price}
          onChange={(event) => onChange("price", event.target.value)}
          className="mt-2 w-full bg-white/60 border border-[#2c3528]/20 px-4 py-3 text-[#2c3528] outline-none focus:border-[#5b7053]"
          placeholder="€14.50"
        />
      </label>
      <label className="block md:col-span-2">
        <span className="text-xs tracking-[0.16em] uppercase text-[#2c3528]/65">Description</span>
        <textarea
          data-testid={`admin-item-description-input-${item.id}`}
          value={item.description}
          onChange={(event) => onChange("description", event.target.value)}
          className="mt-2 min-h-24 w-full bg-white/60 border border-[#2c3528]/20 px-4 py-3 text-[#2c3528] outline-none focus:border-[#5b7053]"
          placeholder="Slow-roasted lamb with potatoes, herbs and feta."
        />
      </label>
      <label className="block">
        <span className="text-xs tracking-[0.16em] uppercase text-[#2c3528]/65">Tag</span>
        <input
          data-testid={`admin-item-tag-input-${item.id}`}
          value={item.tag}
          onChange={(event) => onChange("tag", event.target.value)}
          className="mt-2 w-full bg-white/60 border border-[#2c3528]/20 px-4 py-3 text-[#2c3528] outline-none focus:border-[#5b7053]"
          placeholder="House signature"
        />
      </label>
      <label className="flex items-center gap-3 pt-7">
        <input
          data-testid={`admin-item-available-input-${item.id}`}
          type="checkbox"
          checked={item.available !== false}
          onChange={(event) => onChange("available", event.target.checked)}
          className="h-5 w-5 accent-[#5b7053]"
        />
        <span className="text-sm text-[#2c3528]/75">Visible on public menu</span>
      </label>
    </div>
  </div>
);